// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutsTableComponents-TotalLabel_cls1__3quUL","cls2":"PayoutsTableComponents-TotalLabel_cls2__mlhmP PayoutsTableComponents-TotalLabel_cls1__3quUL"};